import { useEffect, useState } from 'react'
import QBuilderComponentDatePicker from '../../../builder/components/QBuilderComponentDatePicker'
import QBuilderComponentDisplayText from '../../../builder/components/QBuilderComponentDisplayText'
import QBuilderComponentDynamicComponentTable from '../../../builder/components/QBuilderComponentDynamicComponentTable'
import QBuilderComponentFacilities from '../../../builder/components/QBuilderComponentFacilities'
import QBuilderComponentMultiSelect from '../../../builder/components/QBuilderComponentMultiSelect'
import QBuilderComponentSingleSelect from '../../../builder/components/QBuilderComponentSingleSelect'
import QBuilderComponentSubSection from '../../../builder/components/QBuilderComponentSubSection'
import QBuilderComponentTextBox from '../../../builder/components/QBuilderComponentTextBox'
import QBuilderComponentTextInput from '../../../builder/components/QBuilderComponentTextInput'
import QBuilderICDCodesItem from '../../../builder/components/widgets/QBuilderICDCodesItem'
import QBuilderPMBCodesItem from '../../../builder/components/widgets/QBuilderPMBCodesItem'

/**
 * TODO: 
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues}
 * @param {TOD} param0 
 * @returns 
 */
export default function QCaptureComponentWrapper({ cache, accessTypes, component, state, mode, defaultMode, view, onSetData, edit, activeSubsections, onAction, parsedValues, setParsedValues }) {
    const [visible, setVisible] = useState(true)

    const _hasSubsection = (component, activeSubsections) => {
        const _subsect = component.properties.find(p => p.property === 'subsection')
        if (_subsect)
            for (const _ssect of Object.keys(activeSubsections))
                if (activeSubsections[_ssect] === _subsect.values)
                    return true
    }
    useEffect(() => {

        try { if (component.id) setVisible(_hasSubsection(component, activeSubsections)) } catch (e) { }
    }, activeSubsections[component])

    if (component.componentType && accessTypes)
        switch (component.componentType.type) {
            case 'Display Text':
                return (<QBuilderComponentDisplayText
                    cache={cache ? cache : undefined}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    edit={edit}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'Get Input text':
                return (<QBuilderComponentTextInput
                    cache={cache ? cache : undefined}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    edit={edit}
                    onSetData={(value, update) => onSetData(component.id, value, update)}
                    onLoadComplete={() => { }}
                    ComponentId={component.id}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'Multiple Selection':
                return (<QBuilderComponentMultiSelect

                    cache={cache ? cache : undefined}
                    onSetData={(value, update) => onSetData(component.id, value, update)}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    onLoadComplete={() => { }}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    // ComponentId={component.id}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    edit={edit}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'Single Selection':
                return (<QBuilderComponentSingleSelect
                    cache={cache ? cache : undefined}
                    Component={component}
                    onSetData={(value, update) => onSetData(component.id, value, update)}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    accessTypes={accessTypes}
                    onLoadComplete={() => { }}
                    view={view === "New" ? "New" : mode}
                    ComponentId={component.id}
                    defaultMode={defaultMode ? defaultMode : ''}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    edit={edit}
                    mode={mode}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'Date Picker':
                return (<QBuilderComponentDatePicker
                    cache={cache ? cache : undefined}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    edit={edit}
                    onSetData={(value, update) => onSetData(component.id, value, update)}
                    onLoadComplete={() => { }}
                    ComponentId={component.id}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'Facilities':
                return (<QBuilderComponentFacilities
                    cache={cache ? cache : undefined}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    edit={edit}
                    onSetData={(value, update) => onSetData(component.id, value, update)}
                    onLoadComplete={() => { }}
                    ComponentId={component.id}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    mode={mode}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'Sub Section':
                return (<QBuilderComponentSubSection
                    cache={cache ? cache : undefined}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    edit={edit}
                    visible={visible}
                    onSetData={(_componentid, value, update) => onSetData(_componentid, value, update)}
                    onLoadComplete={() => { }}
                    ComponentId={component.id}
                    // subsectionId={component.properties.find(p => p.property === 'subsection').values}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    state={state}
                    stateMode={mode}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'Dynamic Component Table':
                return (<QBuilderComponentDynamicComponentTable
                    cache={cache ? cache : undefined}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    edit={edit}
                    visible={visible}
                    onSetData={(_componentid, value, update) => onSetData(_componentid, value, update)}
                    onLoadComplete={() => { }}
                    ComponentId={component.id}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    state={state}
                    mode={mode}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'ICD10':
                return (<QBuilderICDCodesItem
                    cache={cache ? cache : undefined}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    edit={edit}
                    visible={visible}
                    onSetData={(value, update) => onSetData(component.id, value, update)}
                    onLoadComplete={() => { }}
                    ComponentId={component.id}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    state={state}
                    mode={mode}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'PMB':
                return (<QBuilderPMBCodesItem
                    cache={cache ? cache : undefined}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    edit={edit}
                    visible={visible}
                    onSetData={(value, update) => onSetData(component.id, value, update)}
                    onLoadComplete={() => { }}
                    ComponentId={component.id}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    state={state}
                    mode={mode}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            case 'Text Box':
                return (<QBuilderComponentTextBox
                    cache={cache ? cache : undefined}
                    activeQuestionnaireAssignment={state ? state.details.assignment : {}}
                    view={view === "New" ? "New" : mode}
                    accessTypes={accessTypes}
                    Component={component}
                    defaultMode={defaultMode ? defaultMode : ''}
                    edit={edit}
                    onSetData={(value, update) => onSetData(component.id, value, update)}
                    onLoadComplete={() => { }}
                    ComponentId={component.id}
                    gloabloptions={state ? state.details.options : {}}
                    onChangeMode={() => { }}
                    onAction={(a) => onAction(a)}
                    parsedValues={parsedValues}
                    setParsedValues={setParsedValues ? setParsedValues : () => { console.error('No Parser Available') }}
                />)
            default:
                return <div>Unknown Component Type</div>
        }
}
